import React from 'react';

import { MoreOutlined as DotsHorizontalIcon } from '@ant-design/icons';
import { Button } from 'antd';

type TableActionButtonProps = {
  id?: string;
  onClick: () => void;
  disabled?: boolean;
};

function TableActionButton({ id, onClick, disabled }: TableActionButtonProps) {
  return (
    <Button id={id} shape='circle' onClick={onClick} disabled={disabled} type='text' icon={<DotsHorizontalIcon />} />
  );
}

export { TableActionButton };
